// ZUMII product lightbox: one photo full screen, arrows / swipe / keyboard, replaces Dawn's stacked media modal.
// Uses the gallery's current (variant-filtered) slides, so it always matches what the shopper sees.
(() => {
  if (window.__zumiiLightbox) return;
  window.__zumiiLightbox = true;

  let box, imgEl, counter, items = [], idx = 0, lastFocus = null, startX = 0, startY = 0;

  const big = (src) => {
    try { const u = new URL(src, location.href); u.searchParams.set('width', '2000'); return u.toString(); } catch (e) { return src; }
  };

  const build = () => {
    box = document.createElement('div');
    box.className = 'zumii-lightbox';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Galerie foto');
    box.innerHTML = `
      <button type="button" class="zumii-lightbox__close" aria-label="Închide">&times;</button>
      <button type="button" class="zumii-lightbox__nav zumii-lightbox__nav--prev" aria-label="Imaginea anterioară">&#8249;</button>
      <figure class="zumii-lightbox__stage"><img alt=""></figure>
      <button type="button" class="zumii-lightbox__nav zumii-lightbox__nav--next" aria-label="Imaginea următoare">&#8250;</button>
      <div class="zumii-lightbox__counter" aria-live="polite"></div>`;
    document.body.appendChild(box);
    imgEl = box.querySelector('img');
    counter = box.querySelector('.zumii-lightbox__counter');
    box.querySelector('.zumii-lightbox__close').addEventListener('click', close);
    box.querySelector('.zumii-lightbox__nav--prev').addEventListener('click', () => go(idx - 1));
    box.querySelector('.zumii-lightbox__nav--next').addEventListener('click', () => go(idx + 1));
    box.addEventListener('click', (e) => { if (e.target === box || e.target.classList.contains('zumii-lightbox__stage')) close(); });
    box.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; startY = e.touches[0].clientY; }, { passive: true });
    box.addEventListener('touchend', (e) => {
      if (e.touches.length) return;
      const dx = e.changedTouches[0].clientX - startX, dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) go(idx + (dx < 0 ? 1 : -1));
      else if (dy > 90 && Math.abs(dy) > Math.abs(dx)) close();
    }, { passive: true });
  };

  const go = (i) => {
    if (!items.length) return;
    idx = (i + items.length) % items.length;
    imgEl.src = big(items[idx].src);
    imgEl.alt = items[idx].alt || '';
    counter.textContent = `${idx + 1} / ${items.length}`;
    box.classList.toggle('is-single', items.length < 2);
    [idx + 1, idx - 1].forEach((n) => { const it = items[(n + items.length) % items.length]; if (it) new Image().src = big(it.src); });
  };

  const onKey = (e) => {
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowRight') go(idx + 1);
    else if (e.key === 'ArrowLeft') go(idx - 1);
  };

  const open = (gallery, mediaId) => {
    const slides = [...gallery.querySelectorAll('ul.product__media-list li[data-media-id]')];
    items = slides.map((li) => {
      const im = li.querySelector('img');
      return im ? { id: li.dataset.mediaId, src: im.currentSrc || im.src, alt: im.alt } : null;
    }).filter(Boolean);
    if (!items.length) return false;
    if (!box) build();
    lastFocus = document.activeElement;
    const start = Math.max(0, items.findIndex((it) => it.id === mediaId || mediaId.endsWith('-' + it.id.split('-').pop())));
    document.documentElement.classList.add('zumii-lightbox-open');
    box.classList.add('is-open');
    go(start);
    document.addEventListener('keydown', onKey);
    box.querySelector('.zumii-lightbox__close').focus();
    return true;
  };

  const close = () => {
    if (!box) return;
    box.classList.remove('is-open');
    document.documentElement.classList.remove('zumii-lightbox-open');
    document.removeEventListener('keydown', onKey);
    imgEl.removeAttribute('src');
    lastFocus?.focus?.();
  };

  // Intercept Dawn's media toggle before its modal opens (images only; video/3D keep Dawn's behaviour).
  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('.product__media-toggle');
    if (!toggle) return;
    const opener = toggle.closest('modal-opener');
    if (opener && !opener.classList.contains('product__modal-opener--image')) return;
    const li = toggle.closest('li[data-media-id]');
    const gallery = toggle.closest('media-gallery');
    if (!li || !gallery) return;
    if (open(gallery, li.dataset.mediaId)) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);
})();
